import { RegisteredComponent } from "@builder.io/sdk-react";
import { DLT_FIELD } from "../commonFields";

export const comparisonChartControlsBlockConfig: Omit<
  RegisteredComponent,
  "component"
> = {
  name: "Comparison Chart Controls",
  noWrap: true,
  image:
    "https://p1.aprimocdn.net/solarwinds/01d5afb0-9b14-43c0-8432-b2fe00b482b0/Circle_arrow_Original%20file.svg",
  requiresParent: {
    component: "Comparison Chart",
    message: "Must be within a Comparison Chart component.",
  },
  inputs: [
    {
      name: "leftArrowAriaLabel",
      type: "string",
      defaultValue: "Left Arrow Control",
      required: true,
      localized: true,
    },
    { ...DLT_FIELD, name: "leftArrowDlt", friendlyName: "Left Arrow DLT" },
    { ...DLT_FIELD, name: "leftArrowDld", friendlyName: "Left Arrow DLD" },
    {
      name: "rightArrowAriaLabel",
      type: "string",
      defaultValue: "Right Arrow Control",
      required: true,
      localized: true,
    },
    { ...DLT_FIELD, name: "rightArrowDlt", friendlyName: "Right Arrow DLT" },
    { ...DLT_FIELD, name: "rightArrowDld", friendlyName: "Right Arrow DLD" },
  ],
};
